import {
  Box,
  Button,
  createStyles,
  Grid,
  Select,
  Text,
} from "@mantine/core";
import React, { useRef, useState } from "react";
import "./style.css";
import { DatePickerInput } from "@mantine/dates";
import DateSvg from "../../Svgs/DateSvg";
import moment from "moment";
import { createBillingReportInvoices } from "../../../services/billinginvoice";
import { useSelector } from "react-redux";
import BillingInvoicePDF from "./BillingInvoicePDF";
import { pdf } from "@react-pdf/renderer";
import { useForm } from "@mantine/form";
import { IconChevronDown } from "@tabler/icons-react";

const useStyles = createStyles((theme) => ({
  reportTitleText: {
    color: "#262626",
    textAlign: "left",
    fontFamily: "Inter, sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  reportTitle: {
    background: "#FFF",
    margin: "1rem 0",
    borderRadius: "12px",
    padding: "12px 26px",
  },
  reportContainer: {
    background: "#FFF",
    margin: "1rem 0",
    borderRadius: "12px",
    padding: "12px 26px",
    height: "55vh",
  },
}));

const Reports = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { classes } = useStyles();
  const [typeError, setTypeError] = useState("");
  const [invoiceType, setInvoiceType] = useState("");
  const [dateError, setDateError] = useState("");
  const { profile } = useSelector((state) => state?.profile);

  // Function to generate and download the PDF
  const generateAndDownloadPDF = (billingData) => {
    const doc = <BillingInvoicePDF billingData={billingData} />;

    pdf(doc)
      .toBlob()
      .then((blob) => {
        // Create a temporary download link
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "BillingInvoiceReport.pdf";
        link.click();
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const form = useForm({
    initialValues: {
      name: "",
      startDate: null,
      endDate: null,
    },
  });
  const buttonRef = useRef();

  const onSave = async () => {
    buttonRef?.current?.click();
    form?.validate();
    setTypeError("");
    setDateError("");
    if (!invoiceType) {
      setTypeError("Invoice type is required");
      return;
    }
    if (!startDate || !endDate) {
      setDateError("Both start and end dates are required");
      return;
    }
    if (moment(endDate).isBefore(moment(startDate))) {
      setDateError("End date cannot be earlier than start date");
      return;
    }
    let obj;
    obj = {
      ...form.values,
      startDate: startDate,
      endDate: moment(endDate).endOf("M").toDate(),
      reportType: invoiceType.toLowerCase(),
      admin: profile.user.id,
    };

    let res = await createBillingReportInvoices(obj);

    if (res) {
      generateAndDownloadPDF(res?.data?.billinginvoiceReport);
    }
  };

  return (
    <Box>
      <Box className={classes.reportTitle}>
        <Text className={classes.reportTitleText}>Reports</Text>
      </Box>
      <Box className={classes.reportContainer}>
        <Select
          id="select-type"
          label="Select Type"
          placeholder="Select Type"
          data={[
            { value: "customersales", label: "Customer Sales" },
            { value: "recurringinvoices", label: "Recurring Invoices" },
          ]}
          size="md"
          value={invoiceType}
          onChange={(value) => {
            setInvoiceType(value);
            setTypeError("");
          }}
          error={typeError}
          rightSection={<IconChevronDown color={"#8B8B8B"} />}
        />
        <Grid mt={10}>
          <Grid.Col span={6}>
            <DatePickerInput
              icon={<DateSvg />}
              label="Start Date"
              placeholder="Select start date"
              value={startDate}
              error={dateError}
              clearable
              onChange={setStartDate}
              />
          </Grid.Col>
          <Grid.Col span={6}>
            <DatePickerInput
              clearable
              icon={<DateSvg />}
              label="End Date"
              placeholder="Select end date"
              value={endDate}
              error={dateError}
              onChange={setEndDate}
            />
          </Grid.Col>
        </Grid>
        <Button
          variant="filled"
          color="yellow"
          radius="md"
          size="md"
          mt={30}
          fullWidth
          onClick={onSave}
        >
          Download
        </Button>
      </Box>
    </Box>
  );
};

export default Reports;
